export const parseDate = (dateString: string): Date => {
  if (dateString.includes(' ')) {
    const formattedDate = dateString.replace(' ', 'T');
    return new Date(formattedDate);
  }
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const formatDateLong = (dateString: string): string => {
  const date = parseDate(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDateShort = (dateString?: string): string => {
  if (!dateString) return '';
  const date = parseDate(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};
